<template>
  <div>
    <div class="container">
      <div class="roundblue"></div>
      <div class="row">
        <div class="col-lg-5 col-sm-12">
          <HotelForm></HotelForm>
        </div>
        <div class="col-lg-7 col-sm-12">
          <section class="section">
            <div class="container">
              <div class="row row-grid align-items-center newborder">
                <div class="col-md-12 mb-3">
                  <h4 class="fhhead headpadding">Featured Hotels</h4>
                </div>
                <div
                  class="col-md-12 featuredhotelformobile"
                  v-if="featuredhotels == null"
                >
                  <div class="alert alert-warning">Please wait ......</div>
                </div>
                <div
                  class="col-md-12 featuredhotelformobile"
                  v-if="featuredhotels != null"
                >
                  <carousel
                    v-if="featuredhotels.length > 0"
                    :paginationEnabled="false"
                    :scrollPerPage="false"
                    :navigationEnabled="true"
                    :perPageCustom="[
                      [320, 1],
                      [480, 1],
                      [768, 2],
                    ]"
                    :autoplay="false"
                    :loop="false"
                    :interval="10000"
                    :speed="725"
                  >
                    <slide
                      v-bind:key="fhotel.id"
                      v-for="fhotel in featuredhotels"
                    >
                      <card
                        class="featuredcard minheight"
                        hover
                        body-classes="py-5"
                      >
                        <img
                          v-lazy="fhotel.hotel_image"
                          class="card-img-top featuredimage"
                        />
                        <div class="card-body-alternate">
                          <h6 class="text-primary text-uppercase featuredtitle">
                            {{ fhotel.hotel_name }}
                            <br />
                            <span>
                              <i
                                v-for="index in Number(fhotel.hotel_stars)"
                                v-bind:key="index"
                                class="fa fa-star fa-xs starsize"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </h6>

                          <p class="description mt-3 featuredcity">
                            {{ fhotel.city_name }}
                            <span class="reviews view-pc">
                              {{ fhotel.own_rating }} / 5
                            </span>
                            <br /><span class="displayword"> by HotelLele</span>
                          </p>

                          <RouterLink
                            :to="
                              'hoteldetail?hotelid=' +
                              fhotel.hotel_id +
                              '&tr=1&from=hotelwise'
                            "
                          >
                            <base-button
                              tag="a"
                              href="#"
                              type="primary"
                              class="mt-4"
                              v-on:click="directhotel()"
                              >from ₹
                              {{ fhotel.starting_price }} /-</base-button
                            >
                          </RouterLink>
                        </div>
                      </card>
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="container mt-5">
          <div class="col-lg-12 col-sm-12 newborder mtb-5">
            <div class="row row-grid align-items-center">
              <div class="col-md-12 text-center mb-3">
                <h4 class="chhead headpadding">Hotels by Cities</h4>
              </div>
              <div class="col-md-12" v-if="hotelcities == null">
                <div class="alert alert-warning">Please wait ......</div>
              </div>
              <div class="col-md-12" v-if="hotelcities != null">
                <carousel
                  v-if="hotelcities.length > 0"
                  :paginationEnabled="false"
                  :navigationEnabled="true"
                  :scrollPerPage="true"
                  :perPageCustom="[
                    [320, 1],
                    [480, 1],
                    [768, 2],
                    [992, 4],
                  ]"
                  :touchDrag="true"
                >
                  <slide
                    v-bind:key="fcity.id"
                    v-for="fcity in hotelcities"
                    class="mobilewidth"
                  >
                    <RouterLink
                      :to="
                        'hotellist?city=' +
                        fcity.id +
                        '&cityNames=' +
                        fcity.name +
                        '&tr=1&from=hotelwise'
                      "
                      @click.native="directhotel()"
                    >
                      <div class="card bg-default border-0">
                        <img v-lazy="fcity.city_image" class="card-img-top" />
                        <blockquote class="card-blockquote">
                          <svg
                            preserveAspectRatio="none"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 583 95"
                            class="svg-bg"
                          >
                            <polygon
                              points="0 90, 590 30, 590 99, 0 100"
                              class="fill-default"
                            />
                            <polygon
                              points="0 90, 590 30, 590 99, 0 100"
                              opacity=".2"
                              class="fill-default"
                            />
                          </svg>
                          <h5 class="font-weight-bold text-white">
                            {{ fcity.name }}
                          </h5>
                        </blockquote>
                      </div>
                    </RouterLink>
                  </slide>
                </carousel>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12 newborder">
            <div class="row row-grid align-items-center">
              <div class="col-md-12 mb-3">
                <h4 class="chhead fontformobile headpadding">
                  Hotels with Combo Offers
                </h4>
              </div>
              <div class="col-md-12" v-if="combohotels == null">
                <div class="alert alert-warning">Please wait ......</div>
              </div>
              <div class="row" v-if="combohotels != null">
                <!-- <carousel
                  v-if="combohotels.length > 0"
                  :paginationEnabled="false"
                  :scrollPerPage="true"
                  :navigationEnabled="true"
                  :perPageCustom="[
                    [320, 1],
                      [480, 1],
                      [768, 2],
                      [992, 4],
                  ]"
                  :autoplay="false"
                  :loop="false"
                  :interval="10000"
                  :speed="720"
                > -->
                <div
                  class="col-lg-4 space"
                  v-bind:key="chotel.id"
                  v-for="chotel in combohotels"
                >
                  <card
                    class="newcard featuredcard minheight"
                    hover
                    body-classes="py-5"
                  >
                    <img
                      v-lazy="chotel.hotel_image"
                      class="card-img-top featuredimage"
                    />
                    <div class="card-body-alternate minheighttext">
                      <h6 class="text-primary text-uppercase featuredtitle">
                        {{ chotel.hotel_name }}
                        <br/>
                        <span>
                          <i
                            v-for="index in Number(chotel.hotel_stars)"
                            v-bind:key="index"
                            class="fa fa-star fa-xs starsize"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </h6>
                      <div
                        v-html="chotel.combo_desc"
                        class="overviewtext"
                      ></div>
                      <p class="description mt-3 featuredcity">
                        {{ chotel.city_name }}
                        <span class="reviews view-pc">
                          {{ chotel.own_rating }} / 5
                        </span>
                        <br /><span class="displayword"> by HotelLele</span>
                      </p>
                      <div class="dayandprice">
                        <span>Combo Days {{ chotel.combo_total_days }}</span>
                        <h5 class="price">
                          <s class="red">₹ {{ chotel.combo_gross_amt }} /-</s>
                          <br />
                          ₹ {{ chotel.combo_net_amt }} /-<br />
                          <span class="perperson">Per Person</span>
                        </h5>
                      </div>
                      <RouterLink
                        :to="
                          'hoteldetail?hotelid=' +
                          chotel.hotel_id +
                          '&tr=1&from=combo'
                        "
                        class="booklink"
                      >
                        <base-button
                          tag="a"
                          href="#"
                          type="primary"
                          class="maxwidth"
                          v-on:click="
                            comboclick(
                              chotel.combo_dates.slice(0, 10),
                              chotel.combo_total_days
                            )
                          "
                          >Book Now</base-button
                        >
                      </RouterLink>
                    </div>
                  </card>
                </div>
                <!-- </carousel> -->
              </div>
            </div>
          </div>
        </div>

        <!-- <cityselect class="hotelCitySelect"></cityselect> -->
      </div>

      <!-- <HotelFooter></HotelFooter> -->
    </div>
  </div>
</template>
<script>
import BasicElements from "./components/BasicElements";
import HotelHero from "./components/HotelHero";
import Cityselect from "./components/CitySelect";
import HotelFooter from "./components/HotelFooter";
import HotelForm from "./components/HotelForm";
import { APIURLS } from "../api/constants.js";
import axios from "axios";
import moment from "moment";

export default {
  name: "hotelpage",

  components: {
    HotelHero,
    Cityselect,
    HotelForm,
    HotelFooter,
  },
  data() {
    return {
      hotelcities: null,
      featuredhotels: null,
      combohotels: null,
      datein: new Date(),
      dateout: new Date(new Date().setDate(new Date().getDate() + 1)),
    };
  },
  methods: {
    
    getFeaturedCities() {
      axios.get(APIURLS.GET_HOMEPAGE_DATA).then((response) => {
        // console.log("FeaturedHotels:");
        //console.log(response.data);
        this.hotelcities = response.data.cities;
        this.featuredhotels = response.data.featured_hotels;
        this.combohotels = response.data.combo_hotels;
        // console.log(response.data.cities);
        // console.log(response.data.featured_hotels);
      });
    },
    comboclick(combodatestar, NumbersDay) {
      //var addday=Number(NumbersDay);
      var mydate =
        combodatestar.split("-")[2] +
        "-" +
        combodatestar.split("-")[1] +
        "-" +
        combodatestar.split("-")[0];
      var TempCombodatestar = moment(String(mydate)).format("YYYY-MM-DD");
      var TempCombodateend = moment(String(mydate))
        .add(NumbersDay, "days")
        .format("YYYY-MM-DD");
      var datein = new Date(TempCombodatestar);
      var dateout = new Date(TempCombodateend);
      var datein1 = moment(String(datein)).format("YYYY-MM-DD");
      var dateout1 = moment(String(dateout)).format("YYYY-MM-DD");
      localStorage.setItem("checkin", datein1);
      localStorage.setItem("checkout", dateout1);
      localStorage.setItem("combohotel", "combe");
      localStorage.setItem("trooms", "1");
      localStorage.setItem("comboday", NumbersDay);
      localStorage.setItem("trooms", "1");
      localStorage.setItem("combohotel", "hotel");
      localStorage.setItem("guests", 2);
      localStorage.setItem("totalguest", 2);
      localStorage.setItem("guestsChildren", 0);
      localStorage.setItem("guestsChildrenabove", 0);
    },
    directhotel() {
      var datein = new Date();
      var dateout = new Date(new Date().setDate(new Date().getDate() + 1));
      var datein1 = moment(String(datein)).format("YYYY-MM-DD");
      var dateout1 = moment(String(dateout)).format("YYYY-MM-DD");
      localStorage.setItem("checkin", datein1);
      localStorage.setItem("checkout", dateout1);
      localStorage.setItem("trooms", "1");
      localStorage.setItem("combohotel", "hotel");
      localStorage.setItem("guests", 2);
      localStorage.setItem("totalguest", 2);
      localStorage.setItem("guestsChildren", 0);
      localStorage.setItem("guestsChildrenabove", 0);
    },
  },
  created() {
    this.getFeaturedCities();
  },
};
</script>

<style scoped>
.overviewtext {
  text-align: justify;
}
.maxwidth {
  width: 100%;
}
.price {
  position: relative;
  top: -1.1em;
  text-align: end;
}
.perperson {
  font-weight: 200;
  font-size: 0.5em;
}
.price {
  font-weight: 700;
}
.red {
  color: red;
  font-size: 0.6em;
}
.booklink {
}
.space {
  padding: 1em 2em;
}
.starsize {
  color: #f7dc69;
}
.VueCarousel-slide {
  padding-right: 0.5em !important;
}
.card {
  border: 1px solid #bfc5e0;
  border-radius: 15px;
}
.newcard {
  border: 1px solid #bfc5e0;
  border-radius: 15px;
}
.roundblue {
  width: 100rem;
  height: 95rem;
  background-color: #083578;
  position: absolute;
  top: -63rem;
  left: -79rem;
  transform: translate(50%);
  z-index: -2;
  border-radius: 50%;
  overflow-x: hidden;
}

.browsebystarscontainer {
  text-align: center;
  background: #e7e6e6;
  padding: 1em;
  border-radius: 0.7em;
  margin: 1em;
}
.browsebystarscontainer:hover {
  box-shadow: 0 0 11px rgb(82 80 80 / 54%);
}
.minheighttext {
  min-height: 13rem;
}

.card-lift--hover:hover {
  transform: unset;
}
.checked {
  color: orange;
}
.cmt10 {
  margin-top: 20px !important;
}
.tm6 {
  margin-top: 4.3rem;
}
.tm5 {
  margin-top: 5rem;
}
.test {
  z-index: -1;
}
.hotelCitySelect {
  padding: 1em;
  background: #294b7585;
  border-radius: 1em;
  padding-top: 2em;
}
.hotelCitySelect p {
  color: #ffffff !important;
}
.selectCityLeadText {
  color: #ffffff !important;
}
.featuredimage {
  /* max-height: 12em;
  min-height: 12em; */
  width: 100%;
  height: 100%;
  border-top-left-radius: 14px;
  border-top-right-radius: 15px;

}
.featuredhotelformobile .featuredimage{
   object-fit: cover;

  max-height: 200px;
  min-height: 200px;
}
.featuredcity {
  font-size: 1.1em;
  color: #000000;
  font-weight: bold;
}
.featuredtitle {
  padding-top: 0.5em;
  font-weight: bold;
}
.featuredcard {
  padding: 0;
}
.minheight {
  min-height: 420px;
  width: 98%;
}
.fhhead {
  background: #f7dc69;
  padding: 0.5em;
  margin-top: -0.5%;
  height: 50px;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  text-align: center;
  color: #fff;
  font-weight: 800;
}
.chhead {
  background: #f7dc69;
  height: 45px;
  border-bottom-left-radius: 55%;
  border-bottom-right-radius: 55%;
  text-align: center;
  color: #fff;
  font-weight: 800;
  width: 800px;
  margin: 0 auto;
}

.newborder {
  border: 1px solid #f7dc69;
  border-radius: 15px;
  padding-bottom: 2%;
  padding: 0 0.2rem 0.9rem;
}
.card-body {
  padding-top: 0rem !important;
}

.btn-primary:hover {
  color: #083578;
  background-color: #f7dc69;
  border: 1px solid #f7dc69;
}
.card .card-blockquote {
  padding: 1rem;
}
.mtb-5 {
  margin-bottom: 5rem;
}
.displayword {
  white-space: pre;
  float: right;
  font-size: 0.7rem;
}
.reviews {
  float: right;
}

@media (min-width: 300px) and (max-width: 769px) {
  .roundblue {
    width: 26rem;
    height: 42rem;
    top: 9rem;
    left: -66%;
    border-radius: 0rem;
    margin-left: 0rem;
    display: none;
  }
  .minheight {
    /* min-width: 41vh; */
    /* margin-left: 2%; */
    width: 90%;
    margin: 0 auto;
  }
  .chhead {
    width: 41vh;
  }
  .fontformobile {
    font-size: 1rem;
  }
  .headpadding {
    padding-top: 0.3rem;
  }
  .mt-5 {
    margin-top: 0rem !important;
  }
  .card-body,
  .mobilewidth {
    min-width: calc(100% - 1px);
    max-width: calc(100% - 1px);
  }
  .mtb-5 {
    margin-bottom: 3rem;
  }
  .featuredtitle {
    font-size: 0.75rem;
  }
  .displayword {
    float: right;
    font-size: 0.6rem;
  }
  .featuredhotelformobile {
    padding: 0;
  }
  .VueCarousel-slide {
    padding: 0 !important;
  }
  .card {
    width: 90%;
    margin: 0 auto;
  }
  .bgform {
    box-shadow: 0 0 9px 0px rgb(0 0 0 / 30%);
  }
}

.reviews {
  /* position: absolute; */
  background-color: #6773e6;
  color: #fff;
  border-radius: 10px;
  padding: 3px 5px;
  font-size: 0.8rem;
  font-weight: 600;
  /* float: right;
  right: 2%; */
}
.card-blockquote {
  background: #172b4d;
}
</style>
